import { addons } from '@storybook/manager-api';

import DSATheme from './dsa-theme';

addons.setConfig({
  theme: DSATheme,
});
